import Qty from 'js-quantities';
import { set, get, convert } from '../helpers/UnitHelpers';

class Motor {
    isEmpty() {
        return this.name === undefined && this.serie === undefined;
    }

    /**
     * Create a deep copy of the object.
     * @returns {*}
     */
    copy() {
        return Object.assign(Object.create(this), this);
    }

    isTorque() {
        return name !== null && name !== undefined && name.toLowerCase().startsWith('q');
    }

    equals(motor) {
        return motor.name === this.name && motor.serie === this.serie;
    }

    /**
     * Create an instance form a json object.
     * @param json
     * @returns {MovementProfile}
     */
    static fromJson(json) {
        let motor = new Motor();

        if (json !== undefined) {
            motor.serie = json.serie;
            motor.next = json.next;
            motor.previous = json.previous;
            motor.name = json.name;
            motor.cad = json.cad || null;
            motor.manual = json.manual || null;
            motor.specsheet = json.specs_sheet || null;
            motor.maximum_speed = json.maximum_speed;
            motor.maximum_speed_voltage = json.maximum_speed_voltage;
            motor.bemf = json.bemf;
            motor.coil_mass = json.coil_mass;
            motor.motor_force_constant = json.motor_force_constant;
            motor.peak_current = json.peak_current;
            motor.peak_force = json.peak_force;
            motor.length = json.length;
            motor.width = json.width;
        }

        return motor;
    }

    toJson() {
        let app = {};

        app.serie = this.serie;
        app.next = this.next;
        app.previous = this.previous;
        app.name = this.name;
        app.cad = this.cad || null;
        app.manual = this.manual || null;
        app.specs_sheet = this.specsheet || null;
        app.maximum_speed = this.maximum_speed;
        app.maximum_speed_voltage = this.maximum_speed_voltage;
        app.bemf = this.bemf;
        app.coil_mass = this.coil_mass;
        app.motor_force_constant = this.motor_force_constant;
        app.peak_current = this.peak_current;
        app.peak_force = this.peak_force;
        app.length = this.length;
        app.width = this.width;

        return app;
    }
}

export default Motor;
